/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';

/**
 * User feedback content model for user_feedback events.
 * @export
 * @interface UserFeedbackContent
 */
export interface UserFeedbackContent {
    /**
     * 
     * @type {boolean}
     * @memberof UserFeedbackContent
     */
    positive: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserFeedbackContent
     */
    feedbackMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserFeedbackContent
     */
    conversationId?: string | null;
    /**
     * 
     * @type {Array<Message>}
     * @memberof UserFeedbackContent
     */
    conversationContent: Array<Message>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFeedbackContent
     */
    categories?: Array<string> | null;
}

/**
 * Check if a given object implements the UserFeedbackContent interface.
 */
export function instanceOfUserFeedbackContent(value: object): value is UserFeedbackContent {
    if (!('positive' in value) || value['positive'] === undefined) return false;
    if (!('conversationContent' in value) || value['conversationContent'] === undefined) return false;
    return true;
}

export function UserFeedbackContentFromJSON(json: any): UserFeedbackContent {
    return UserFeedbackContentFromJSONTyped(json, false);
}

export function UserFeedbackContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFeedbackContent {
    if (json == null) {
        return json;
    }
    return {
        
        'positive': json['positive'],
        'feedbackMessage': json['feedback_message'] == null ? undefined : json['feedback_message'],
        'conversationId': json['conversation_id'] == null ? undefined : json['conversation_id'],
        'conversationContent': ((json['conversation_content'] as Array<any>).map(MessageFromJSON)),
        'categories': json['categories'] == null ? undefined : json['categories'],
    };
}

export function UserFeedbackContentToJSON(json: any): UserFeedbackContent {
    return UserFeedbackContentToJSONTyped(json, false);
}

export function UserFeedbackContentToJSONTyped(value?: UserFeedbackContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'positive': value['positive'],
        'feedback_message': value['feedbackMessage'],
        'conversation_id': value['conversationId'],
        'conversation_content': ((value['conversationContent'] as Array<any>).map(MessageToJSON)),
        'categories': value['categories'],
    };
}

